import React from 'react';

import { Button, Image, Table, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { useAppDispatch } from 'segments/hooks';
import i18n from 'segments/i18n';
import { defaultPaginationConfig } from 'segments/utils/constants/common';

import { convertImageListToTable, ImageInfo, useDeleteImageMutation } from 'features/imagesStore';
import { changeActiveModal } from 'features/modals';


export interface TableData extends ImageInfo {
  key: string;
}

type Props = {
  items: ImageInfo[];
  itemsTotal?: number;
  isLoading?: boolean;
  currentPage?: number;
  defaultPageSize?: number;
  onPageChange?: (page: number, pageSize: number) => void;
};

export const ImageStoreTable = (props: Props) => {
  const {
    items,
    itemsTotal = 0,
    isLoading,
    currentPage = 1,
    defaultPageSize = 30,
    onPageChange,
  } = props;

  const dispatch = useAppDispatch();
  const { t } = useTranslation(undefined, { keyPrefix: 'table' });
  const [deleteCourt, { isLoading: isImageDeleting }] = useDeleteImageMutation();

  const onCreateClick = () => {
    dispatch(changeActiveModal('create-image-modal'));
  };
  return (
    <Table<TableData>
      size="small"
      dataSource={convertImageListToTable(items)}
      loading={isLoading}
      scroll={{ x: 1200 }}
      pagination={{
        ...defaultPaginationConfig,
        defaultPageSize,
        current: currentPage,
        total: itemsTotal,
        onChange: onPageChange,
      }}
    >
      <Table.Column<TableData>
        title={t('image', 'Изоброжение')}
        dataIndex="url"
        render={(url: string) => (
          url === null
            ? <Typography.Text style={{ fontSize: '12px' }}>{i18n.t('image-store.errors.not-seted')}</Typography.Text>
            : <Image height={40} src={url} alt={i18n.t('image-store.errors.not-founded')} style={{ fontSize: '10px' }} />
        )}
        width={100}
      />
      <Table.Column<TableData>
        title={t('id', 'ID')}
        dataIndex="id"
        render={(id: string) =>
          <Typography.Text italic copyable>{id}</Typography.Text>}
        width={450}
      />
      <Table.Column<TableData>
        title={t('register', 'Дата регистрации')}
        dataIndex="created"
      />
      <Table.Column<TableData>
        dataIndex="id"
        width={60}
        title={<Button type="primary" onClick={onCreateClick}>{t('create')}</Button>}
        render={(id: number) => (
          <Button type="primary" danger disabled={isImageDeleting} onClick={() => {
            deleteCourt(id);
          }}
          >
            {t('delete', 'Удалить')}
          </Button>
        )}
      />
    </Table>
  );
};
